export default "__VITE_ASSET__BftxPvvD__"